import { render } from "./contactcard.vue?vue&type=template&id=5319efe3"
import script from "./contactcard.vue?vue&type=script&lang=js"
export * from "./contactcard.vue?vue&type=script&lang=js"

import "./contactcard.vue?vue&type=style&index=0&id=5319efe3&lang=css"

import exportComponent from "../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-user-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__